import React from 'react'

const IcLine = (props) => {
    return <svg {...props} width={18} height={18} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1={1} y1="8.5" x2={17} y2="8.5" stroke="black" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
}

export default IcLine
